import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import {

  getBillCorrectionDetails,
  getBillCorrectionList,
  getBillCorrectionTypes,
  getBillPreview,
  getBillsFromSearch,
  getBillTemplates,
  getChoices,
  getCorrectedBillDetails,
  getOutstandingBills,
  initiateBillCorrection,
  patchBillCorrection,
  postApproveBill,
  postGenerateBill,
} from "./api";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { queryClient } from "@shared/api/queries/queryClient";
import { useNavigate } from "react-router-dom";
import { downloadBillTemplate } from "../api";

export const useChoices = (choice: string, remoteUtilityId?: string) =>
  useSmartQuery(
    QueryKeyFactory.module.bx.choices(choice),
    () => getChoices(choice, remoteUtilityId),
    {
      enabled: !!choice,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0,
    }
  );

export const useBillSearch = (queryParams: {
  page?: number;
  searchData?: string;
  remoteUtilityId?: string;
}) => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billSearch(queryParams.searchData, queryParams.page),
    () => getBillsFromSearch(queryParams),
  );
};

export const useBillCorrectionTypes = () => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billCorrectionTypes(),
    () => getBillCorrectionTypes(),
  );
};

export const useInitiateBillCorrection = () => {
  return useSmartMutation(
    (payload: Record<string, any>) => initiateBillCorrection(payload),
  )
}

export const useBillCorrectionDetails = (billId: number) => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billCorrectionDetails(billId),
    () => getBillCorrectionDetails(billId),
    {
      enabled: !!billId,
    }
  );
};

export const usePatchBillCorrection = () => {
  return useSmartMutation(
    ({ id, type, payload }: Record<string, any>) =>
      patchBillCorrection({ id, type, payload })
  );
};

export const useBillChangesDetails = (correctionId) => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.impactAnalysisDetails(correctionId),
    () => getCorrectedBillDetails(correctionId),
    {
      enabled: !!correctionId,
      staleTime: 0
    }
  );
};

export const useBillTemplates = (remoteUtilityId) => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billTemplates(),
    () => getBillTemplates(remoteUtilityId),
    {
      enabled: !!remoteUtilityId,
    }
  );
};

export const useGenerateCorrectedBill = (correctionId) => {
  return useSmartMutation(
    () => postGenerateBill(correctionId),
  )
}

export const useBillPreview = (correctionId?: number) => {
  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billPreview(correctionId),
    () => downloadBillTemplate(String(correctionId)),
    {
      enabled: !!correctionId,
    }
  );
};

export const useApproveCorrectedBill = (correctionId) => {
  return useSmartMutation(
    (payload: any) => postApproveBill(correctionId, payload),
  )
}

export const useBillCorrectionList = (remoteUtilityId, search, page) => {

  return useSmartQuery(
    QueryKeyFactory.module.bx.billCorrection.billCorrectionList(search, page),
    () => getBillCorrectionList(remoteUtilityId, search, page),
    {
      enabled: !!remoteUtilityId,
    }
  );
};